import { render, staticRenderFns } from "./TaxonomiesSettings.vue?vue&type=template&id=4f723573&"
import script from "./TaxonomiesSettings.vue?vue&type=script&lang=js&"
export * from "./TaxonomiesSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports